import { Injectable } from '@angular/core';
import { UserRoles } from '@app/@graphql/models';
import jwtDecode from 'jwt-decode';
import { Claims, ClaimUser } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ClaimsService {
  getClaims<T = any>(token: string): T {
    return jwtDecode(token) as T;
  }

  getRoles<T = Claims>(claims: Claims): UserRoles[] {
    const roleKey = Object.keys(claims).find(key => key.endsWith('role'));
    const roles = !!claims[roleKey] ? claims[roleKey] : [];
    return Array.isArray(roles) ? roles : [roles];
  }

  getUserData(token: string): ClaimUser {
    const claims = this.getClaims<Claims>(token);
    return {
      roles: this.getRoles(claims),
      userName: claims.name
    };
  }
}

